import { useState, useRef, ReactNode } from 'react';
import { createPortal } from 'react-dom';

// A lightweight hover tooltip that renders into document.body via a portal so it
// is never clipped by ancestors with `overflow: hidden` or a transform (e.g. the
// project cards). Positioned as a fixed box centred above the trigger.
const HoverTooltip = ({
  content,
  children,
  className = '',
}: {
  content: ReactNode;
  children: ReactNode;
  className?: string;
}) => {
  const [pos, setPos] = useState<{ x: number; y: number } | null>(null);
  const ref = useRef<HTMLSpanElement>(null);

  const show = () => {
    const r = ref.current?.getBoundingClientRect();
    if (r) setPos({ x: r.left + r.width / 2, y: r.top });
  };
  const hide = () => setPos(null);

  return (
    <span
      ref={ref}
      onMouseEnter={show}
      onMouseLeave={hide}
      className={`inline-flex items-center ${className}`}
    >
      {children}
      {pos &&
        createPortal(
          <div
            style={{
              position: 'fixed',
              left: pos.x,
              top: pos.y - 8,
              transform: 'translate(-50%, -100%)',
              zIndex: 9999,
            }}
            className="pointer-events-none rounded-lg bg-[#1A1F2B] text-white text-xs px-3 py-2 shadow-[0_8px_24px_rgba(0,0,0,0.18)] whitespace-nowrap leading-relaxed"
          >
            {content}
          </div>,
          document.body
        )}
    </span>
  );
};

export default HoverTooltip;
